import { createContext } from 'rax';
const MenuContext = createContext({});
export default MenuContext;
